// src/components/LoginForm.js
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../services/api";
import styles from "../css/Login.module.css"; // <-- ¡Importamos el nuevo CSS!
import { FiLogIn, FiEye, FiEyeOff, FiClock } from "react-icons/fi"; // <-- Iconos profesionales

const LoginForm = ({ onLogin }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [warning, setWarning] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setWarning("");
    setIsLoading(true);

    try {
      const res = await loginUser(form);
      console.log("🔍 Respuesta del login:", res); // Debug log
      
      if (res.success) {
        localStorage.setItem("token", res.token);
        
        // Verificar si hay advertencia de expiración próxima
        if (res.warning) {
          console.log("⚠️ Advertencia detectada:", res.warning); // Debug log
          setWarning(res.warning.message);
          console.log("🔔 Estado de warning actualizado:", res.warning.message); // Debug log
          // Mostrar advertencia pero permitir login
          setTimeout(() => {
            console.log("⏰ Timeout completado, navegando..."); // Debug log
            onLogin();
          }, 5000); // Aumentar tiempo para leer la advertencia
        } else {
          console.log("✅ Login sin advertencias"); // Debug log
          onLogin(); // Navegación inmediata si no hay advertencias
        }
      } else {
        // Verificar si es error de acceso expirado
        if (res.accessExpired) {
          navigate("/access-expired");
          return;
        }
        setError(res.message || "Login fallido. Por favor, intenta de nuevo.");
      }
    } catch (err) {
      console.error("Login error:", err);
      if (err.response?.status === 403 && err.response?.data?.accessExpired) {
        navigate("/access-expired");
        return;
      }
      setError("Ocurrió un error inesperado. Por favor, intenta de nuevo.");
    } finally {
      setIsLoading(false); // ✅ Asegura que el loading se detenga siempre
    }
  };

  return (
    <div className={styles.authCard}>
      <div className={styles.header}>
        <h2>Bienvenido de Vuelta</h2>
        <p>Ingresa tus credenciales para acceder a Community PRO.</p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        {/* ✅ Mensaje de error visible y bien posicionado */}
        {error && (
          <p className={`${styles.message} ${styles.error}`}>{error}</p>
        )}

        {/* ✅ Mensaje de advertencia para expiración próxima */}
        {warning && (
          <div className={`${styles.message} ${styles.warning}`}>
            <FiClock size={16} style={{ marginRight: "0.5rem" }} />
            {warning}
          </div>
        )}
        
        {/* Debug: Mostrar estado de warning */}
        {console.log("🔍 Estado de warning en render:", warning)}

        <div className={styles.inputGroup}>
          {/* ✅ Usamos <label> para accesibilidad y usabilidad */}
          <label htmlFor="email">Correo Electrónico</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="tu@email.com"
            onChange={handleChange}
            value={form.email}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="password">Contraseña</label>
          <div className={styles.passwordWrapper}>
            <input
              id="password"
              name="password"
              type={isPasswordVisible ? "text" : "password"}
              placeholder="••••••••"
              onChange={handleChange}
              value={form.password}
              required
            />
            {/* ✅ Botón accesible para el toggle de contraseña */}
            <button
              type="button"
              className={styles.passwordToggle}
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
              aria-label="Mostrar u ocultar contraseña"
            >
              {isPasswordVisible ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        <div className={styles.secondaryActions}>
          <Link to="/password-reset" className={styles.link}>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        {/* ✅ Botón con estado de carga y feedback visual */}
        <button type="submit" className={styles.button} disabled={isLoading}>
          {isLoading ? (
            <div className={styles.spinner}></div>
          ) : (
            <>
              <FiLogIn />
              <span>Iniciar Sesión</span>
            </>
          )}
        </button>

        {/* Enlace de registro removido temporalmente - solo admins pueden crear usuarios */}
      </form>
    </div>
  );
};

export default LoginForm;
